import React from 'react'
import { TableHead } from '../ui/table'
import { cn } from 'src/lib/utils'
import { ReactComponent as SortUp } from '../Icon/sort-up.svg'
import { ReactComponent as SortDown } from '../Icon/sort-down.svg'

function ListSortHead({ className, field, fieldString, sort, setSort, children }) {
  const isSorted = sort.field === field

  const handleClick = () => {
    if (setSort) {
      setSort({ field, desc: !sort.desc, fieldString })
    }
  }

  return (
    <TableHead
      className={cn('cursor-pointer select-none hover:text-walme-text transition-colors', className)}
      onClick={handleClick}
    >
      <div className="flex items-center gap-1">
        {children}
        {isSorted && (
          <span className="inline-flex text-walme-primary">
            {sort.desc ? <SortDown /> : <SortUp />}
          </span>
        )}
      </div>
    </TableHead>
  )
}

export default ListSortHead
